import { client as request } from "./request";
import { FolderEntry } from "@/models/file";
import store from "../store";
import { ResponseEntries } from "./report-api";

export async function getDocumentEntries(projectId: any, currentFolderId: any) {
  const res = await request.get("get_document_entries.php", {
    projectId,
    currentFolderId
  });

  if (!store.getters.user.permissions.includes("service/project_read")) {
    return {
      ...res,
      entries: (res.entries || [])
        .filter((item: { secret: boolean }) => {
          return !item.secret;
        })
        .map(FolderEntry.create)
    } as ResponseEntries;
  }

  return {
    ...res,
    entries: (res.entries || []).map(FolderEntry.create)
  } as ResponseEntries;
}

/**
 * 図面・書類を保存する
 */
export async function saveDocumentEntry(data: FormData) {
  await request.post("save_document_entry.php", data).catch(e => {
    alert(e);
  });
}

/**
 * 図面・書類を削除する
 */
export async function deleteDocumentEntry(id: any) {
  const data = new FormData();
  data.append("id", id);
  await request.post("delete_document_entry.php", data);
}

export async function readDocumentEntry(entryId: any) {
  const data = new FormData();
  data.append("entryId", entryId);
  await request.post("read_document_entry.php", data);
}
